//#region IMPORTS
import env from '../config/env';
import service from '../api/conciliationMonitor.service';
import permission from '../api/permissions.service';
//#endregion IMPORTS

//#region CONSTANTS

const initialData = {
    securityPermission: null,
    conciliationDailyData: [],
    bankingList: [],
    noPermitted: ''
}
//#endregion CONSTANTS

//#region TYPES
const SECURITY_PERMISSIONS = 'SECURITY_PERMISSIONS';
const LOAD_TOTAL_CONCILIATION_DAILY = 'LOAD_TOTAL_CONCILIATION_DAILY';
const LIST_COLLECTING_ENTITIES = 'LIST_COLLECTING_ENTITIES';
const RESPONSE_ERROR = 'RESPONSE_ERROR';
//#endregion TYPES

//#region REDUCER

export default function historyReducer(state = initialData, action) {
    switch (action.type) {
        case SECURITY_PERMISSIONS:
            return { ...state, securityPermission: action.payload };
        case LOAD_TOTAL_CONCILIATION_DAILY:
            return { ...state, conciliationDailyData: action.payload };
        case LIST_COLLECTING_ENTITIES:
            return { ...state, bankingList: action.payload };
        case RESPONSE_ERROR:
            return { ...state, noPermitted: action.payload };
        default:
            return { ...state };
    }
}
//#endregion REDUCER

//#region ACTIONS
export const getPermissions = (username, action) => async (dispatch) => {
    const response = await permission.validPermission(
        env.transaction.conciliationMonitor,
        username,
        env.app.systemCode, action);
    dispatch({
        type: SECURITY_PERMISSIONS,
        payload: response
    });
    return response;
}

export const getBankingList = (country) => async (dispatch) => {
    const response = await service.getBankingList(country).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    let data = [];
    response.forEach(element => {
        data.push({
            value: element.code,
            label: element.name,
            country:element.country
        });
    });
    dispatch({
        type: LIST_COLLECTING_ENTITIES,
        payload: data
    });

}

export const getConciliationDaily = (json) => async () => {
    const response = await service.getConciliationDaily(json).then((r) => { return r });
    return response;
}

export const getConciliationList = (json) => async () => {
    const response = await service.getConciliationList(json).then((r) => { return r });
    return response;
}

export const getConciliationListBank = (json) => async () => {
    const response = await service.getConciliationListBank(json).then((r) => { return r });
    return response;
}

export const getConciliationListIncome = (json) => async () => {
    const response = await service.getConciliationListIncome(json).then((r) => { return r });
    return response;
}

//#endregion ACTIONS
